<template>
  <div>
    <div class="form-group">
      <el-form-item>
        <label
          class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
        >
          Placeholder (Range Values)
        </label>
        <el-input v-model="field.placeholder1"></el-input>
      </el-form-item>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'templates-formComponents-Placeholder',
    props: ['field'],
    data() {
      return {};
    },
  };
</script>

<style lang="scss"></style>
